const { Component } = wp.element;

export class SearchTarget extends Component {

  render() {
    return (
      <div className="form-group field">
        <label className="filter-label">検索対象</label><br />
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" id="option1" checked={ 'title' === this.props.target }
                 onClick={ () => { this.props.changeHandler('title') } } />
            <label className="form-check-label" htmlFor="option1">見出し</label>
        </div>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" id="option2" checked={ 'both' === this.props.target }
                 onClick={ () => { this.props.changeHandler('both') } }/>
            <label className="form-check-label" htmlFor="option2">全文</label>
        </div>
      </div>
    );
  };
}
